

























import {
	computed,
	defineComponent,
	Ref,
	watch,
} from '@vue/composition-api';
import deepEqual from 'deep-equal';
import EventPage from '@front-app/modules/event/components/EventPage.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import { checkIfEventVisibleToUser } from '@front-app/util/permission';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { FullEvent } from '@front-app/services/EventsApi/EventModel';
import { useEventStore } from '@front-app/modules/event/store/Event';
import { trackEventSimpleAction, trackGroupEventAction } from '@front-app/services/ActionApi/ActionApi';
import { GroupAuditAction } from '@front-app/services/ActionApi/ActionModel';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';

export default defineComponent({
	components: {
		ErrorCard,
		EventPage,
		LoaderState,
		ColumnContainer,
		PaddedContent,
	},
	props: {
		eventId: {
			type: String,
			required: true,
		},
		groupId: {
			type: String,
			default: '',
		},
	},
	setup(props) {
		const eventStore = useEventStore();
		const event: Ref<undefined | FullEvent> = computed(() => eventStore.getById(props.eventId));
		const isEventVisibleToUser = computed(() => checkIfEventVisibleToUser(CurrentUserStore.isCsr.value, event.value));

		const trackActionProps = computed(() => [props.groupId, props.eventId]);
		watch(trackActionProps, (curr, prev) => {
			const [groupId, eventId] = curr;
			if (!groupId || !eventId || deepEqual(curr, prev)) {
				return;
			}
			trackGroupEventAction(groupId, eventId, GroupAuditAction.VIEW_EVENT_PAGE);
		}, { immediate: true });

		const {
			track: trackEventFetch,
			isLoading: isEventLoading,
		} = useAsyncStatus();
		const fetchEvent = async (a: string, b?: string) => {
			if (a === b) {
				return;
			}
			await trackEventFetch(eventStore.fetch(props.eventId));
			// We also want to track raw views for the event, in addition to for the group, above
			trackEventSimpleAction(props.eventId, GroupAuditAction.VIEW);
		};
		watch(() => props.eventId, fetchEvent, { immediate: true });

		return {
			event,
			isEventLoading,
			isEventVisibleToUser,
		};
	},
});
